import * as React from "react";
import { viewDate } from "src/common/formats";
import { AttrData } from "../AttributeHistrory.types";

export const AttrDate: React.FC<AttrData> = ({ value }) =>
  viewDate(value, "DD.MM.YYYY");
